import { render } from "./InvestmentPage.vue?vue&type=template&id=15769982&scoped=true"
import script from "./InvestmentPage.vue?vue&type=script&lang=js"
export * from "./InvestmentPage.vue?vue&type=script&lang=js"

import "./InvestmentPage.vue?vue&type=style&index=0&id=15769982&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15769982"]])

export default __exports__